<template>
  <div :class="$root.isSmartCenterEnabled() ? 'main-menu-with-smart-center' : ''">
    <sidebar-menu @toggle-collapse="toggleMainMenu" ref="sideBarMenu" :menu="menu" :collapsed="collapsed" :showChild="false" :disableHover="!collapsed">
      <span slot="toggle-icon"><font-awesome-icon :icon="['fas', 'bars']"/></span>
      <span slot="dropdown-icon"><font-awesome-icon :icon="['fas', 'angle-right']"/></span>
      <template v-slot:footer>
        <footer-main v-show="!collapsed" footer-class="footer-main-menu"></footer-main>
      </template>
    </sidebar-menu>
  </div>
</template>
<script>
import router from "../../router";
import MenuMixins from "../../mixins/MenuMixins.vue";
import FooterMain from "../../components/FooterMain.vue";
import { SidebarMenu } from "vue-sidebar-menu";
import SmartCenterService from "../../services/smart.center.service";
import GoogleService from "../../services/google.service";

import "vue-sidebar-menu/src/scss/vue-sidebar-menu.scss";
import "font-awesome/scss/font-awesome.scss";

export default {
  name: "MainMenu",
  mixins: [MenuMixins],
  components: {
    SidebarMenu,
    FooterMain
  },
  router,
  methods: {
    toggleMainMenu: function() {
      this.trackCollapseEvent("Main Menu Toggle - Bottom of Menu");
    },
    goToSmartCenter: function() {
      GoogleService.logClickEvent("Smart Center Link", "Header - Top Right-hand Corner", 0, this);
    },
    trackCollapseEvent: function(categoryName) {
      let label = this.collapsed ? "open" : "close";
      GoogleService.logClickEvent(categoryName, label, 0, this);
      this.onToggleCollapse();
    },
    onToggleCollapse: function() {
      this.collapsed = !this.collapsed;
      let showMainMenu = this.$root.getShowMainMenu();
      this.$root.setShowMainMenu(!showMainMenu);
    }
  },
  props: {
    isAdmin: {
      type: Boolean,
      default: false
    },
    isInsider: {
      type: Boolean,
      default: false
    },
    isExecutive: {
      type: Boolean,
      default: false
    },
    isPower: {
      type: Boolean,
      default: false
    },
    isBasic: {
      type: Boolean,
      default: false
    }        
  },
  data() {
    return {
      link: "",
      collapsed: !this.$root.getShowMainMenu(),
      smartCenterTooltipConfig: {
        content: "Click to go the the Smart Center. ",
        trigger: "hover",
        placement: "right",
        delay: { show: 500, hide: 500 }
      },
      menu: [
        {
          href: { name: "competitive-dashboard" },
          title: "Competitive Dashboard",
          class: "no-border-top",
          icon: "fa-duotone fa-flag-checkered fa-xl"
        },
      ],
      designMenu: {
          title: "Design",
          icon: "fa-duotone fa-wrench fa-xl",
          child: [
            {
              href: { path: "/design/sections" },
              title: "Sections",
              class: "sidebar-adjustment sections",
              icon: {
                class: "fa-duotone fa-puzzle ml-1",
                element: "i",
              }
            },
            {
              href: { path: "/design/ideal" },
              title: "Competitors",
              icon: {
                class: "fa-duotone fa-ranking-star",
                element: "i",
              }
            },
            {
              href: { path: "/design/needs" },
              title: "Needs",
//              icon: "fa-duotone fa-brain-circuit" //margin-left: 3px
              icon:{
                class: "fa-duotone fa-brain-circuit ml-1",
                element: "i",
              }
            },
            {
              href: { path: "/design/segments" },
              title: "Segments",
              icon: "fa-duotone fa-screen-users",
            },
            {
              href: { path: "/design/preview" },
              title: "Preview",
              class: "sidebar-adjustment preview",
              icon: "fa-duotone fa-eyes"
            }
          ]
      },
      respondentMenu: {
          title: "Respondent",
          icon: "fa-duotone fa-users fa-xl",
          child: [
            {
              href: { path: "/respondent/invitations" },
              title: "Invitations",
              class: "sidebar-adjustment invitations",
              icon: "fa-duotone fa-envelope-open-text ml-1"
            },
            {
              href: { path: "/respondent/waves" },
              title: "Waves",
              class: "sidebar-adjustment waves",
              icon: {
                class: "fa-duotone fa-calendar-clock ml-1",
                element: "i",

              }
            },
            {
              href: { path: "/respondent/metrics" },
              title: "Metrics",
              class: "sidebar-adjustment metrics",
              icon: {
                class: "fa-duotone fa-chart-mixed-up-circle-dollar ml-1",
                element: "i"
              }
            },
            {
              href: { path: "/respondent/clusters" },
              title: "Groups",
              class: "sidebar-adjustment groups",
              icon: {
                class: "fa-duotone fa-layer-group  ml-1",
                element: "i"
              }
            },
            {
              href: "/respondent/download",
              title: "Download",
              class: "sidebar-adjustment download",
              icon: {
                class: "fa-duotone fa-laptop-arrow-down  download icon",
                element: "i"
              }
            }
          ]
      },
      analyticsMenu: {
          title: "Analytics",
          icon: "fa-duotone fa-bullseye-arrow fa-xl",
          child: [
            {
              href: { path: "/analytics/report" },
              title: "Cards",
              class: "sidebar-adjustment report-item",
              icon: "fa-duotone fa-cards-blank"
            },

          ]
      },
      preferencesMenu: {
          title: "Preferences",
          icon: "fa-duotone fa-id-card fa-xl",
          child: [
            {
              href: { name: "user-settings" },
              title: "My Account",
              class: "sidebar-adjustment user",
              icon: "fa-duotone fa-key"
            },

          ]
      },
      adminMenu: [
        {
          title: "Administration",
          icon: {
            element: "font-awesome-icon",
            attributes: {
              icon: "cogs"
            }
          },
          child: [
            {
              href: "/playground",
              title: "Playground",
              class: "fa-w-16 sidebar-adjustment responses-item",
              icon: {
                element: "font-awesome-icon",
                class: "fa-w-16",
                attributes: {
                  icon: "th-list"
                }
              }
            },
            {
              href: "/admin/survey-status",
              title: "Survey Status",
              class: "sidebar-adjustment survey-status-item",
              icon: {
                element: "font-awesome-icon",
                class: "fa-w-16",
                attributes: {
                  icon: "th-list"
                }
              }
            },
            {
              href: "/admin/survey-list",
              title: "Survey List",
              class: "sidebar-adjustment survey-list-item",
              icon: {
                element: "font-awesome-icon",
                class: "fa-w-16",
                attributes: {
                  icon: "th-list"
                }
              }
            },
            {
              href: "/admin/saved-card-list",
              title: "Saved Card List",
              class: "sidebar-adjustment survey-list-item",
              icon: {
                element: "font-awesome-icon",
                class: "fa-w-16",
                attributes: {
                  icon: "th-list"
                }
              }
            },
            {
              href: "/admin/waves-list",
              title: "Waves List",
              class: "sidebar-adjustment survey-list-item",
              icon: {
                element: "font-awesome-icon",
                class: "fa-w-16",
                attributes: {
                  icon: "th-list"
                }
              }
            },
/*
            {
              href: { path: "/admin/add-client" },
              title: "Add Client",
              class: "sidebar-adjustment add-client-item",
              icon: {
                element: "font-awesome-icon",
                class: "fa-w-16",
                attributes: {
                  icon: "university"
                }
              }
            },
*/            
            {
              href: { path: "/admin/client-list" },
              title: "Client List",
              class: "sidebar-adjustment client-list-item",
              icon: {
                element: "font-awesome-icon",
                class: "fa-w-16",
                attributes: {
                  icon: "th-list"
                }
              }
            },
/*            
            {
              href: { path: "/admin/add-user" },
              title: "Add User",
              class: "sidebar-adjustment",
              icon: {
                element: "font-awesome-icon",
                class: "fa-w-16",
                attributes: {
                  icon: "user-plus"
                }
              }
            },
*/            
            {
              href: { path: "/admin/user-list" },
              title: "User List",
              class: "sidebar-adjustment user-list-item",
              icon: {
                element: "font-awesome-icon",
                class: "fa-w-16",
                attributes: {
                  icon: "th-list"
                }
              }
            },
            {
              href: { path: "/admin/locale-list" },
              title: "Locale List",
              class: "sidebar-adjustment sector-list-item",
              icon: {
                element: "font-awesome-icon",
                class: "fa-w-16",
                attributes: {
                  icon: "fa-flag"
                }
              }
            },
            {
              href: { path: "/admin/survey-locale-list" },
              title: "Survey Locale List",
              class: "sidebar-adjustment sector-list-item",
              icon: {
                element: "font-awesome-icon",
                class: "fa-w-16",
                attributes: {
                  icon: "fa-flag"
                }
              }
            },
            {
              href: { path: "/admin/advisor-list" },
              title: "Advisor List",
              class: "sidebar-adjustment nps",
              icon: {
                element: "font-awesome-icon",
                class: "fa-w-16",
                attributes: {
                  icon: "briefcase"
                }
              }
            },         
            {
              href: { path: "/admin/admin-metric-group-list" },
              title: "Metric Group List",
              class: "sidebar-adjustment nps",
              icon: {
                element: "font-awesome-icon",
                class: "fa-w-16",
                attributes: {
                  icon: "money-bill"
                }
              }
            },         
            {
              href: { path: "/admin/admin-metric-list" },
              title: "Metric List",
              class: "sidebar-adjustment nps",
              icon: {
                element: "font-awesome-icon",
                class: "fa-w-16",
                attributes: {
                  icon: "money-bill"
                }
              }
            },         
/*               
            {
              href: { path: "/admin/partial-responses" },
              title: "Partial Survey Responses",
              class: "sidebar-adjustment partial-responses-item",
              icon: {
                element: "font-awesome-icon",
                class: "fa-w-14",
                attributes: {
                  icon: "database"
                }
              }
            },
*/            
          {
              href: { path: "/admin/dashboard-card-list" },
              title: "Dashboard Card List",
              class: "sidebar-adjustment company-list-item",
              icon: {
                element: "font-awesome-icon",
                class: "fa-w-16",
                attributes: {
                  icon: "th-list"
                }
              }
            },
            {
              href: { path: "/admin/company-list" },
              title: "Benchmark Company List",
              class: "sidebar-adjustment company-list-item",
              icon: {
                element: "font-awesome-icon",
                class: "fa-w-16",
                attributes: {
                  icon: "th-list"
                }
              }
            },
            {
              href: { path: "/admin/benchmark-company-list" },
              title: "Benchmark List",
              class: "sidebar-adjustment benchmark-list-item",
              icon: {
                element: "font-awesome-icon",
                class: "fa-w-16",
                attributes: {
                  icon: "th-list"
                }
              }
            },
            {
              href: { path: "/admin/content-list" },
              title: "Content List",
              class: "sidebar-adjustment content-list-item",
              icon: {
                element: "font-awesome-icon",
                class: "fa-w-16",
                attributes: {
                  icon: "th-list"
                }
              }
            },
            
            {
              href: { path: "/admin/nps-email" },
              title: "NPS Email",
              class: "sidebar-adjustment nps",
              icon: {
                element: "font-awesome-icon",
                class: "fa-w-16",
                attributes: {
                  icon: "id-card"
                }
              }
            },
            {
              href: { path: "/admin/responses" },
              title: "Responses",
              class: "sidebar-adjustment nps",
              icon: {
                element: "font-awesome-icon",
                class: "fa-w-16",
                attributes: {
                  icon: "id-card"
                }
              }
            }
          ]
        },
        {
          title: "Monitor",
          icon: {
            element: "font-awesome-icon",
            attributes: {
              icon: "tachometer-alt"
            }
          },
          child: [
            {
              href: { path: "/monitor/application-error" },
              class: "sidebar-adjustment",
              title: "Application Error List",
              icon: {
                element: "font-awesome-icon",
                class: "fa-w-14",
                attributes: {
                  icon: "user-secret"
                }
              }
            },
            {
              href: { path: "/monitor/response-message" },
              class: "sidebar-adjustment",
              title: "Response Message List",
              icon: {
                element: "font-awesome-icon",
                class: "fa-w-14",
                attributes: {
                  icon: "user-secret"
                }
              }
            },
            {
              href: { path: "/monitor/job-list" },
              class: "sidebar-adjustment",
              title: "Job List",
              icon: {
                element: "font-awesome-icon",
                class: "fa-w-14",
                attributes: {
                  icon: "user-secret"
                }
              }
            },
            {
              href: { path: "/monitor/performance" },
              class: "sidebar-adjustment",
              title: "Performance",
              icon: {
                element: "font-awesome-icon",
                class: "fa-w-14",
                attributes: {
                  icon: "user-secret"
                }
              }
            },
            {
              href: { path: "/google-analytics-interview" },
              title: "Google Anlytics - Interview",
              class: "sidebar-adjustment",
              icon: {
                element: "font-awesome-icon",
                class: "fa-w-14",
                attributes: {
                  icon: "user-secret"
                }
              }
            },
            {
              href: { path: "/google-analytics-admin" },
              title: "Google Anlytics - Admin",
              class: "sidebar-adjustment",
              icon: {
                element: "font-awesome-icon",
                class: "fa-w-14",
                attributes: {
                  icon: "user-secret"
                }
              }
            }
          ]
        }
      ],
      libraryMenuItem: {
          href: "/library",
          title: "Library",
          class: "sidebar-adjustment",
          icon: "fa-duotone fa-books fa-xl"
      },
      contactUsMenuItem: {
          href: "/contact-us",
          title: "wRatings Support",
          icon: {
            element: "img",
            class: "wratings-logo-image",
            attributes: {
              src: "/img/wRatings-2021-W-support.png"
            }
          }
      },
      quickGuideMenuItem: {
          href: "/training-center",
          title: "Sales Growth University",
          icon: "fa-duotone fa-graduation-cap fa-xl"
      },
      advisorMenuItem: {
          href: { name: "advisor" },
          title: "Advisor",
          class: "sidebar-adjustment user",
          icon: "fa-duotone fa-briefcase-arrow-right"
      },
      chartsMenuItem:  {
        href: { name: "client-settings" },
        title: "Charts",
        class: "sidebar-adjustment charts",
        icon: "fa-duotone fa-circle-half"
      },
      dashboardMenuItem: {
        href: { name: "dashboard-layout" },
        title: "Dashboard",
        class: "sidebar-adjustment dashboard",
        icon: "fa-duotone fa-grid-horizontal"
      },
      ranksMenuItem: {
        href: { path: "/analytics/ranks" },
        class: "sidebar-adjustment ranks",
        title: "Ranks",
        icon: {
          class: "fa-duotone fa-gauge-circle-bolt",
          element: "i"
        }              
      },
      // Rates Goes Here
      profileMenuItem: {
        href: { path: "/analytics/profiles" },
        title: "Profiles",
        class: "sidebar-adjustment profiles",
        icon: {
          class: "fa-duotone fa-jet-fighter ml-1",
          element: "i"
        }
      },
      matchMenuItem:{
        href: { path: "/analytics/match" },
        title: "Match",
        class: "sidebar-adjustment match",
        icon: {
          class:"fa-duotone fa-code-compare ml-1",
          element: "i"
        }
      },
      trendsMenuItem:{
        href: { path: "/analytics/trends" },
        title: "Trends",
        class: "sidebar-adjustment trends",
        icon: {
          class: "fa-duotone fa-display-chart-up ml-1",
          element: "i"
        }
      },
      ratesMenuItem: {
        href: { path: "/respondent/rates" },
        title: "Rates",
        class: "sidebar-adjustment rates",
        /*size: "lg",*/
        icon: {
          class: "fa-duotone fa-poll-people icons",
          element: "i"
            }      
      },
      predictiveMenuItem:{
        href: { path: "/analytics/predictive" },
        class: "sidebar-adjustment predictive",
        title: "Predictive",
        icon: "fa-duotone fa-hand-holding-circle-dollar ml-1"
      },
      printReportMenuItem:{
        href: { path: "/print-report" },
        class: "sidebar-adjustment print",
        title: "Reports",
        icon: {
          class: "fa-duotone fa-file-powerpoint ml-1",
          element: "i"
        }
      }
    };
  },
  created() {
    this.preferencesMenu.child.push(this.chartsMenuItem);
    this.preferencesMenu.child.push(this.dashboardMenuItem);
    if (!this.isInsider && !this.isExecutive && !this.isPower && !this.isBasic) {
      this.menu.push(this.designMenu);
    }
    if (!this.isInsider && !this.isExecutive) {
      this.menu.push(this.respondentMenu);
    }
    this.analyticsMenu.child.push(this.ratesMenuItem);
    this.analyticsMenu.child.push(this.profileMenuItem);
    this.analyticsMenu.child.push(this.matchMenuItem);
    this.analyticsMenu.child.push(this.predictiveMenuItem);
    this.analyticsMenu.child.push(this.ranksMenuItem);
    this.analyticsMenu.child.push(this.trendsMenuItem);
    this.analyticsMenu.child.push(this.printReportMenuItem);
    this.menu.push(this.analyticsMenu);
    this.preferencesMenu.child.push(this.advisorMenuItem);
    this.menu.push(this.preferencesMenu);
    this.menu.push(this.libraryMenuItem);
    this.menu.push(this.quickGuideMenuItem);
    this.menu.push(this.contactUsMenuItem);
    if (this.isAdmin) {
      this.menu = this.menu.concat(this.adminMenu);
    }
    this.link = SmartCenterService.SMART_CENTER_URL;
    this.link += "/";
    this.link += SmartCenterService.SMART_CENTER_LOGIN_PARAMETERS;
  },
  mounted() {},
  watch: {
    $route() {
      this.$refs.sideBarMenu.$data.mobileItem = null;
    }
  },
  computed: {}
};
</script>
